import { useQuery } from "react-query";
import { RestError } from "../../services/rest-service/RestService";
import UserRoleAdministrationService from "../../services/user-role-administration-service/UserRoleAdministrationService";
import { BaseUseQueryParameters } from "../BaseUseQueryParameters";
import { keys } from "./Keys";
import { IObjectSecurityModel } from "../../common/models/IObjectSecurityModel";

export type UseEffectiveRolePermissionsParameters = {
    groupID: number;
    organizationID: number;
    roleIDs: Array<number>;
} & BaseUseQueryParameters<Array<IObjectSecurityModel>>;

export function useEffectiveRolePermissions({
    groupID,
    organizationID,
    roleIDs,
    enabled,
    onError,
    onSuccess
}: UseEffectiveRolePermissionsParameters) {
    return useQuery<Array<IObjectSecurityModel>, RestError>(
        keys.effectiveRolePermissionList(organizationID, roleIDs),
        ({ signal }) => {
            return UserRoleAdministrationService.getEffectiveRolePermissions(groupID, organizationID, roleIDs, signal);
        },
        {
            enabled,
            onError,
            onSuccess
        }
    );
}